module.exports = __webpack_public_path__ + "app/assets/images/woman4-ecaf8ef000f82d542c3c7d81ee561d03.jpg";